export enum InternalLinkTypeEnum {
  PAGE = 'page',
  PRODUCT = 'product',
  PERSON = 'person',
  PRESS_RELEASE = 'pressRelease',
  BLOG_POST = 'blogPost',
  COLLECTION = 'collection',
  GLOBAL_PRODUCT = 'globalProduct',
  GLOBAL_PRODUCT_COLLECTION = 'globalProductCollection',
}
